/**
 * Rejection used when Eppo has neither a cached snapshot nor a CDN configuration.
 *
 * OpenFeature still needs the rejection to keep the provider in ERROR, but the failure is not
 * actionable on our side, so the shared OpenFeature logger reports it at debug level.
 */
export class EppoInitializationError extends Error {
    name = 'EppoInitializationError';
    constructor() {
        super('Eppo client initialization failed.');
    }
}
//# sourceMappingURL=eppoInitializationError.js.map